"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const antd_1 = require("antd");
require("./ForgotPassword.scss");
const strings_1 = require("../../../assets/strings/strings");
const response_codes_1 = require("../../../assets/constants/response_codes");
const message_utils_1 = __importDefault(require("../../../utils/message_utils"));
const auth_requests_1 = require("../../../dataSource/auth_requests");
const RoutesPaths_1 = require("../../../routes/RoutesPaths");
const AccessWrapper_1 = __importDefault(require("../accessWrapper/AccessWrapper"));
const users_1 = require("../../../utils/users");
const ForgotPassword = () => {
    const history = (0, react_router_dom_1.useHistory)();
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [emailSent, setEmailSent] = (0, react_1.useState)('');
    const [form] = antd_1.Form.useForm();
    (0, react_1.useEffect)(() => {
        if ((0, users_1.checkUserIsAuth)()) {
            history.push(RoutesPaths_1.routesPaths.root);
        }
        document.title = '360 Suítes - Recuperar senha';
    }, [history]);
    const handleSubmit = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const email = form.getFieldValue('email');
        setLoading(true);
        const response = yield (0, auth_requests_1.forgotPassword)({ email: email.toLowerCase() });
        setLoading(false);
        switch (response.code) {
            case response_codes_1.ForgotPasswordCodes.SUCCESS:
                message_utils_1.default.success({
                    message: strings_1.ForgotPasswordMessages.verifyYourEmail,
                    description: strings_1.ForgotPasswordMessages.instructionsSent,
                });
                setEmailSent(email);
                break;
            case response_codes_1.ForgotPasswordCodes.error.USER_NOT_FOUND:
                message_utils_1.default.error({
                    message: strings_1.ForgotPasswordMessages.userNotFound,
                    description: strings_1.ForgotPasswordMessages.verifyAndTryAgain,
                });
                break;
            default:
                message_utils_1.default.error({
                    description: strings_1.ForgotPasswordMessages.verifyAndTryAgain,
                });
                break;
        }
    }), [form]);
    return (react_1.default.createElement("div", { className: "ForgotPassword" },
        react_1.default.createElement(AccessWrapper_1.default, { showTerms: false },
            react_1.default.createElement("div", { className: "form-container" },
                react_1.default.createElement("div", { className: "forgot-header" },
                    react_1.default.createElement("span", null, "Recuperar "),
                    "minha senha"),
                react_1.default.createElement("div", { className: "forgot-message" },
                    react_1.default.createElement("span", null, "Esqueceu sua senha?"),
                    react_1.default.createElement("br", null),
                    "N\u00E3o se preocupe. \u00C9 s\u00F3 nos dizer seu e-mail que enviaremos um link e um c\u00F3digo de acesso para voc\u00EA cadastrar uma nova senha."),
                !emailSent ? (react_1.default.createElement(antd_1.Form, { form: form, className: "forgot-form", onFinish: () => handleSubmit(), noValidate: true },
                    react_1.default.createElement(antd_1.Form.Item, { name: "email", rules: [
                            {
                                required: true,
                                message: strings_1.FieldsMessages.email.insertYourEmail,
                            },
                            {
                                type: 'email',
                                message: strings_1.FieldsMessages.email.invalidEmailFormat,
                            },
                            {
                                pattern: /^[a-z,A-z,0-9,@,.,_,-]+$/,
                                message: strings_1.FieldsMessages.email.dontUseSpecialCharacters,
                            },
                        ] },
                        react_1.default.createElement(antd_1.Input, { className: "input-field", type: "email", placeholder: "E-mail" })),
                    react_1.default.createElement(antd_1.Form.Item, null,
                        react_1.default.createElement(antd_1.Button, { type: "primary", htmlType: "submit", className: "btn-forgot", loading: isLoading }, strings_1.ForgotPasswordMessages.confirm)))) : (react_1.default.createElement("div", { className: "success-message" },
                    "As instru\u00E7\u00F5es para cadastrar uma nova senha foram enviadas para o e-mail",
                    react_1.default.createElement("span", null,
                        " ",
                        emailSent))),
                react_1.default.createElement("div", { className: "forgot-footer" },
                    react_1.default.createElement("div", { className: "row" },
                        react_1.default.createElement("span", null, "\u00A0"),
                        react_1.default.createElement(react_router_dom_1.Link, { to: RoutesPaths_1.routesPaths.root }, strings_1.ForgotPasswordMessages.backToLogin)))))));
};
exports.default = ForgotPassword;
